export enum KontaktTyp {
  KUNDE = 'KUNDE',
  INTERESSENT = 'INTERESSENT',
}

export enum InteressentenStatus {
  NEU = 'NEU',
  ERSTGESPRAECH_ERFOLGT = 'ERSTGESPRAECH_ERFOLGT',
  ANGEBOT = 'ANGEBOT',
  NACHGEFASST = 'NACHGEFASST',
  ANGENOMMEN = 'ANGENOMMEN',
  NICHT_ANGENOMMEN = 'NICHT_ANGENOMMEN',
  INAKTIV = 'INAKTIV',
}

export const interessentenStatusOptions = [
  { value: InteressentenStatus.NEU, label: 'Neu' },
  { value: InteressentenStatus.ERSTGESPRAECH_ERFOLGT, label: 'Erstgespräch erfolgt' },
  { value: InteressentenStatus.ANGEBOT, label: 'Angebot erstellt' },
  { value: InteressentenStatus.NACHGEFASST, label: 'Angebot nachgefasst' },
  { value: InteressentenStatus.ANGENOMMEN, label: 'Angenommen' },
  { value: InteressentenStatus.NICHT_ANGENOMMEN, label: 'Nicht angenommen' },
  { value: InteressentenStatus.INAKTIV, label: 'Inaktiv' },
] as const;

/**
 * Interessenten ohne (oder mit unbekanntem) Status gelten überall als NEU. Funnel, Tabellenfilter
 * und Label müssen dieselbe Normalisierung benutzen, sonst zählt der Funnel andere Datensätze als
 * die Tabelle anzeigt.
 */
export const getVertriebsStatus = (status: InteressentenStatus | null | undefined) =>
  interessentenStatusOptions.some(option => option.value === status)
    ? (status as InteressentenStatus)
    : InteressentenStatus.NEU;

export const getInteressentenStatusLabel = (status: InteressentenStatus | null | undefined) =>
  interessentenStatusOptions.find(option => option.value === getVertriebsStatus(status))!.label;

export interface KontaktOrganisation {
  typ: KontaktTyp;
  id: string;
  organisation: string;
  operativerAnsprechpartner: string | null;
  email: string | null;
  telefonnummer: string | null;
  quelle: string | null;
  vertriebsStatus: InteressentenStatus | null;
  angebotsnummer: string | null;
  angebotslink: string | null;
  bemerkung: string | null;
  zuletztBearbeitet: string | null;
  stadt: string | null;
  postleitzahl: string | null;
  strasse: string | null;
  hausnummer: string | null;
  adresszusatz: string | null;
  creationDate: string;
  updateDate: string;
}

export type Kunde = KontaktOrganisation;

export type Interessent = Kunde & {
  typ: KontaktTyp.INTERESSENT;
  vertriebsStatus: InteressentenStatus;
};

export type CreateKundeDTO = Omit<Kunde, 'id' | 'creationDate' | 'updateDate'>;

export type CreateInteressentDTO = CreateKundeDTO & {
  typ: KontaktTyp.INTERESSENT;
  vertriebsStatus: InteressentenStatus;
};

export type UpdateKundeDTO = Partial<CreateKundeDTO & { id: string }>;
